import React from "react";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Button from "components/CustomButtons/CustomButton";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import PrintIcon from "@material-ui/icons/PictureAsPdf";
import TableRowsIcon from "@material-ui/icons/TableChart";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Typography from "@material-ui/core/Typography";

const COLORS = {
  main: "#13816F",
  pastel1: "#CFF0EA",
  pastel2: "#E3F7F3",
};

const fmtMoney = (v) =>
  typeof v === "number"
    ? v.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    : Number(v || 0).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

export default function Premium({
  infos = [],
  forma = {},
  title = "",
  timezones = {},
  report_tz = "",
  onGenerateCsv,
  onGeneratePdf,
  onBack,
}) {
  return (
    <div className="container-fluid" style={{ padding: 20 }}>
      <form id="report_form">
        {forma &&
          Object.entries(forma).map(([field_name, field_value]) => (
            <input
              key={field_name}
              type="hidden"
              name={field_name}
              value={field_value}
              readOnly
            />
          ))}
      </form>
      <div className="cl-mcont">
        <GridContainer style={{ paddingTop: 20 }}>
          <GridItem xs={12}>
            <div
              className="block-flat"
              style={{ padding: 20, background: "#fff", borderRadius: 8 }}
            >
              {/* Header */}
              <GridContainer style={{ marginBottom: 16 }}>
                <GridItem xs={12} sm={6}>
                  <Typography variant="h6">
                    {report_tz
                      ? `${timezones?.[report_tz]} - ${report_tz.toUpperCase()}`
                      : ""}
                  </Typography>
                  <Typography variant="h5">{title}</Typography>
                </GridItem>
                <GridItem xs={12} sm={6}>
                  <GridContainer>
                    <GridItem xs={12} sm={4}>
                      <Button
                        variant="green"
                        startIcon={<PrintIcon />}
                        onClick={() => onGeneratePdf(4, "pdf")}
                        style={{ width: "100%" }}
                      >
                        PDF
                      </Button>
                    </GridItem>
                    <GridItem xs={12} sm={4}>
                      <Button
                        variant="green"
                        startIcon={<TableRowsIcon />}
                        onClick={() => onGenerateCsv(4, "csv")}
                        style={{ width: "100%" }}
                      >
                        CSV
                      </Button>
                    </GridItem>
                    <GridItem xs={12} sm={4}>
                      <Button
                        style={{
                          background: "#FFF",
                          borderColor: COLORS.main,
                          color: COLORS.main,
                          border: "1px solid",
                          width: "100%",
                        }}
                        startIcon={<ArrowBackIcon />}
                        onClick={onBack}
                      >
                        Back To Reports
                      </Button>
                    </GridItem>
                  </GridContainer>
                </GridItem>
              </GridContainer>
              {/* Date + Company */}
              <GridContainer style={{ marginBottom: 20 }}>
                <GridItem xs={12} sm={2}>
                  Date: {new Date().toLocaleString()}
                </GridItem>
                <GridItem
                  xs={12}
                  sm={10}
                  style={{ textAlign: "right", fontSize: 20 }}
                >
                  HDI Seguros, S.A. de C.V.
                </GridItem>
              </GridContainer>
              {/* Main Table */}
              <TableContainer component={Paper}>
                <Table>
                  <TableBody>
                    {infos.map((info, idxInfo) => (
                      <React.Fragment key={idxInfo}>
                        <TableRow>
                          <TableCell
                            colSpan={16}
                            style={{
                              background: COLORS.main,
                              color: "#fff",
                              fontWeight: 700,
                            }}
                          >
                            {info.agency?.code} - {info.agency?.name}
                          </TableCell>
                        </TableRow>
                        <TableRow
                          style={{
                            background: COLORS.pastel1,
                            color: "#000",
                            textAlign: "center",
                          }}
                        >
                          <TableCell>Term</TableCell>
                          <TableCell>Premium %</TableCell>
                          <TableCell>Count %</TableCell>
                          <TableCell>#Pol</TableCell>
                          <TableCell>Refunded</TableCell>
                          <TableCell>Net</TableCell>
                          <TableCell>Total Policy Fee</TableCell>
                          <TableCell>Agent Policy Fee</TableCell>
                          <TableCell>MGA Policy Fee</TableCell>
                          <TableCell>Ins. CO Policy Fee</TableCell>
                          <TableCell>PD</TableCell>
                          <TableCell>Theft</TableCell>
                          <TableCell>MedExp</TableCell>
                          <TableCell>CSL</TableCell>
                          <TableCell>Road</TableCell>
                          <TableCell>Legal</TableCell>
                        </TableRow>
                        {info.details &&
                          Object.entries(info.details).map(
                            ([rowName, rowVal]) => (
                              <TableRow
                                key={rowName}
                                className="odd gradeX"
                                style={{ textAlign: "right" }}
                              >
                                <TableCell>{rowName}</TableCell>
                                <TableCell>
                                  {fmtMoney(rowVal.premium_pct)}%
                                </TableCell>
                                <TableCell>
                                  {fmtMoney(rowVal.count_pct)}%
                                </TableCell>
                                <TableCell>{fmtMoney(rowVal.count)}</TableCell>
                                <TableCell>
                                  ${fmtMoney(rowVal.refunded)}
                                </TableCell>
                                <TableCell>${fmtMoney(rowVal.net)}</TableCell>
                                <TableCell>
                                  ${fmtMoney(rowVal.total_policy_fee)}
                                </TableCell>
                                <TableCell>
                                  ${fmtMoney(rowVal.agent_policy_fee)}
                                </TableCell>
                                <TableCell>
                                  ${fmtMoney(rowVal.mga_policy_fee)}
                                </TableCell>
                                <TableCell>
                                  ${fmtMoney(rowVal.ins_co_policy_fee)}
                                </TableCell>
                                <TableCell>${fmtMoney(rowVal.pd)}</TableCell>
                                <TableCell>${fmtMoney(rowVal.theft)}</TableCell>
                                <TableCell>
                                  ${fmtMoney(rowVal.medical)}
                                </TableCell>
                                <TableCell>${fmtMoney(rowVal.csl)}</TableCell>
                                <TableCell>${fmtMoney(rowVal.road)}</TableCell>
                                <TableCell>${fmtMoney(rowVal.legal)}</TableCell>
                              </TableRow>
                            )
                          )}
                        {/* Totales */}
                        <TableRow
                          className="odd gradeX"
                          style={{ textAlign: "right" }}
                        >
                          <TableCell>
                            <strong>{info.totales.term}</strong>
                          </TableCell>
                          <TableCell>
                            <strong>
                              {fmtMoney(info.totales.premium_pct)}%
                            </strong>
                          </TableCell>
                          <TableCell>
                            <strong>{fmtMoney(info.totales.count_pct)}%</strong>
                          </TableCell>
                          <TableCell>
                            <strong>{fmtMoney(info.totales.count)}</strong>
                          </TableCell>
                          <TableCell>
                            <strong>${fmtMoney(info.totales.refunded)}</strong>
                          </TableCell>
                          <TableCell>
                            <strong>${fmtMoney(info.totales.net)}</strong>
                          </TableCell>
                          <TableCell>
                            <strong>
                              ${fmtMoney(info.totales.total_policy_fee)}
                            </strong>
                          </TableCell>
                          <TableCell>
                            <strong>
                              ${fmtMoney(info.totales.agent_policy_fee)}
                            </strong>
                          </TableCell>
                          <TableCell>
                            <strong>
                              ${fmtMoney(info.totales.mga_policy_fee)}
                            </strong>
                          </TableCell>
                          <TableCell>
                            <strong>
                              ${fmtMoney(info.totales.ins_co_policy_fee)}
                            </strong>
                          </TableCell>
                          <TableCell>
                            <strong>${fmtMoney(info.totales.pd)}</strong>
                          </TableCell>
                          <TableCell>
                            <strong>${fmtMoney(info.totales.theft)}</strong>
                          </TableCell>
                          <TableCell>
                            <strong>${fmtMoney(info.totales.medical)}</strong>
                          </TableCell>
                          <TableCell>
                            <strong>${fmtMoney(info.totales.csl)}</strong>
                          </TableCell>
                          <TableCell>
                            <strong>${fmtMoney(info.totales.road)}</strong>
                          </TableCell>
                          <TableCell>
                            <strong>${fmtMoney(info.totales.legal)}</strong>
                          </TableCell>
                        </TableRow>
                      </React.Fragment>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              {/* Bottom Buttons */}
              <GridContainer style={{ marginTop: 16 }}>
                <GridItem xs={12} sm={6}>
                  &nbsp;
                </GridItem>
                <GridItem xs={12} sm={6}>
                  <GridContainer>
                    <GridItem xs={12} sm={4}>
                      <Button
                        variant="green"
                        startIcon={<PrintIcon />}
                        onClick={() => onGeneratePdf(4, "pdf")}
                        style={{ width: "100%" }}
                      >
                        PDF
                      </Button>
                    </GridItem>
                    <GridItem xs={12} sm={4}>
                      <Button
                        variant="green"
                        startIcon={<TableRowsIcon />}
                        onClick={() => onGenerateCsv(4, "csv")}
                        style={{ width: "100%" }}
                      >
                        CSV
                      </Button>
                    </GridItem>
                    <GridItem xs={12} sm={4}>
                      <Button
                        style={{
                          background: "#FFF",
                          borderColor: COLORS.main,
                          color: COLORS.main,
                          border: "1px solid",
                          width: "100%",
                        }}
                        startIcon={<ArrowBackIcon />}
                        onClick={onBack}
                      >
                        Back To Reports
                      </Button>
                    </GridItem>
                  </GridContainer>
                </GridItem>
              </GridContainer>
            </div>
          </GridItem>
        </GridContainer>
      </div>
    </div>
  );
}
